module.exports = __webpack_public_path__ + "img/availableColors@2x.29b9d16.jpg";